exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".phone-number-cell[data-v-01b46290] {\n  width: 200px;\n}\n.card-icon-text[data-v-01b46290] {\n  color: white;\n}\n.md-theme-default a[data-v-01b46290]:not(.md-button) {\n  color: black;\n}\n.action-btn-icon[data-v-01b46290] {\n  margin-left: 5px;\n}\n.frequent-address-col[data-v-01b46290] {\n  width: 25%;\n}\n", ""]);

// exports
